export default __webpack_public_path__ + "static/media/TIP.5eaccb34.png";